"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToExpressCart = addToExpressCart;
exports.generateBasketGUID = void 0;
/**
 * Generates a random GUID (Globally Unique Identifier) in the format 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.
 * The GUID is generated using random numbers and follows the version 4 UUID standard.
 *
 * @returns {string} A randomly generated GUID.
 */
const generateBasketGUID = () => self.crypto.randomUUID();

/**
 * Adds a product package to the express cart.
 *
 * @param {Object} params The parameters for adding to the express cart.
 * @param {string} params.productPackage The ID of the product package to add.
 * @param {string|null} params.term The term associated with the product package (null for one-time fees).
 * @param {string} params.itc The ITC code for the product package.
 * @param {string} params.addToCartUrl The URL to send the add to cart request to.
 * @returns {Promise<void>} A promise that resolves when the request is complete.
 */
exports.generateBasketGUID = generateBasketGUID;
async function addToExpressCart({
  productPackage,
  term,
  itc,
  addToCartUrl,
  onError = () => null
}) {
  if (!productPackage || !itc || !addToCartUrl) {
    throw new Error('productPackage, itc, and addToCartUrl are required');
  }
  const packageData = {
    pkgid: productPackage
  };

  // Only include term if it's provided (null/undefined means one-time fee)
  if (term !== null && typeof term !== 'undefined') {
    packageData.term = term;
  }
  const body = JSON.stringify({
    packages: [packageData],
    itc
  });
  try {
    const response = await fetch(addToCartUrl, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });
    if (!response.ok) {
      let errorMessage = `Server responded with status ${response.status}`;
      try {
        const errorData = await response.json();
        if (errorData && errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (error) {
        // Ignore parsing errors
      }
      throw new Error(errorMessage);
    }
    return response.json();
  } catch (error) {
    await onError(error);
    throw error;
  }
}